// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   DESIGN SYSTEM - Lovable Profile
   ========================================= */

:root {
  /* Core palette - Sophisticated slate-navy with warm accents */
  --background: hsl(40, 30%, 98%);
  --foreground: hsl(222, 47%, 11%);

  --card: hsl(0, 0%, 100%);
  --card-foreground: hsl(222, 47%, 11%);

  --popover: hsl(0, 0%, 100%);
  --popover-foreground: hsl(222, 47%, 11%);

  /* Primary - Deep ocean teal */
  --primary: hsl(197, 71%, 28%);
  --primary-foreground: hsl(0, 0%, 100%);

  /* Secondary - Warm sand */
  --secondary: hsl(40, 30%, 96%);
  --secondary-foreground: hsl(222, 47%, 11%);

  /* Muted - Soft gray-lavender */
  --muted: hsl(220, 14%, 96%);
  --muted-foreground: hsl(220, 9%, 46%);

  /* Accent - Rich amber/gold */
  --accent: hsl(38, 92%, 50%);
  --accent-foreground: hsl(222, 47%, 11%);

  /* Destructive */
  --destructive: hsl(0, 84%, 60%);
  --destructive-foreground: hsl(0, 0%, 100%);

  /* Borders & inputs */
  --border: hsl(220, 13%, 91%);
  --input: hsl(220, 13%, 91%);
  --ring: hsl(197, 71%, 28%);

  --radius: 1rem;

  /* Custom profile-specific tokens */
  --profile-bg: hsl(40, 30%, 98%);
  --profile-card: hsl(0, 0%, 100%);
  --profile-heading: hsl(222, 47%, 15%);
  --profile-text: hsl(222, 32%, 20%);
  --profile-muted: hsl(220, 9%, 46%);
  --profile-border: hsl(220, 20%, 90%);

  /* Edit mode - warm amber tints */
  --edit-bg: hsl(45, 60%, 97%);
  --edit-border: hsl(38, 70%, 75%);
  --edit-accent: hsl(38, 92%, 50%);
  --edit-input-bg: hsl(45, 50%, 99%);

  /* View mode - clean, elegant */
  --view-bg: hsl(0, 0%, 100%);
  --view-text: hsl(222, 32%, 25%);
  --view-accent: hsl(197, 71%, 35%);

  /* Tag/pill colors */
  --tag-bg: hsl(197, 50%, 95%);
  --tag-text: hsl(197, 71%, 28%);
  --tag-tech-bg: hsl(150, 50%, 95%);
  --tag-tech-text: hsl(150, 60%, 30%);
  --tag-nontech-bg: hsl(280, 40%, 96%);
  --tag-nontech-text: hsl(280, 50%, 40%);

  /* Status badges */
  --badge-success-bg: hsl(150, 60%, 94%);
  --badge-success-text: hsl(150, 70%, 28%);
  --badge-warning-bg: hsl(45, 90%, 94%);
  --badge-warning-text: hsl(25, 80%, 35%);
  --badge-info-bg: hsl(200, 70%, 94%);
  --badge-info-text: hsl(200, 80%, 30%);

  /* Gradients */
  /* Matched to Home page: #0f0f23 -> #1a1a2e -> #16213e */
  --gradient-hero: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
  --gradient-card: linear-gradient(145deg, hsl(0, 0%, 100%) 0%, hsl(40, 30%, 98%) 100%);
  --gradient-edit: linear-gradient(145deg, hsl(45, 60%, 98%) 0%, hsl(38, 70%, 96%) 100%);
  --gradient-button: linear-gradient(135deg, hsl(38, 92%, 50%) 0%, hsl(28, 90%, 48%) 100%);
  --gradient-tab-active: linear-gradient(135deg, #1a1a2e 0%, #2a2a4e 100%);
  /* Adjusted active tab to match theme */

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 hsl(220, 13%, 11%, 0.03);
  --shadow-md: 0 4px 12px -1px hsl(220, 13%, 11%, 0.06), 0 2px 4px -2px hsl(220, 13%, 11%, 0.04);
  --shadow-lg: 0 10px 30px -4px hsl(220, 13%, 11%, 0.08), 0 4px 6px -4px hsl(220, 13%, 11%, 0.04);
  --shadow-card: 0 4px 20px -4px hsl(220, 13%, 11%, 0.07);
  --shadow-edit: 0 4px 20px -4px hsl(38, 92%, 50%, 0.15);
}

/* =========================================
   BASE STYLES & RESETS
   ========================================= */
* {
  box-sizing: border-box;
}

/* Fix for full screen: Reset body margin/padding which might be missing after Home unmounts */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: var(--profile-bg);
  /* Prevent white edges during load */
}

/* Dark Mode Variables */
[data-theme='dark'] {
  --background: hsl(222, 47%, 11%);
  --foreground: hsl(40, 30%, 98%);

  --card: hsl(222, 47%, 13%);
  --card-foreground: hsl(40, 30%, 98%);

  --primary: hsl(197, 71%, 40%);
  /* Slightly lighter for dark mode visibility */
  --primary-foreground: hsl(0, 0%, 100%);

  --muted: hsl(217, 33%, 17%);
  --muted-foreground: hsl(215, 20%, 65%);

  --border: hsl(217, 33%, 20%);
  --input: hsl(217, 33%, 20%);

  /* Profile specific overrides */
  --profile-bg: hsl(222, 47%, 10%);
  --profile-card: hsl(222, 47%, 13%);
  --profile-heading: hsl(40, 30%, 98%);
  --profile-text: hsl(215, 20%, 85%);
  --profile-muted: hsl(215, 20%, 65%);
  --profile-border: hsl(217, 33%, 20%);

  /* Edit mode */
  --edit-bg: hsl(222, 47%, 12%);
  --edit-border: hsl(38, 70%, 40%);
  --edit-input-bg: hsl(222, 47%, 15%);
  --gradient-edit: linear-gradient(145deg, hsl(222, 47%, 14%) 0%, hsl(222, 47%, 10%) 100%);
  --shadow-edit: 0 8px 30px -4px rgba(0, 0, 0, 0.4);

  /* View mode */
  --view-bg: hsl(222, 47%, 13%);
  --view-text: hsl(215, 20%, 85%);

  /* Tags */
  --tag-bg: hsl(197, 50%, 20%);
  --tag-text: hsl(197, 71%, 80%);
  --tag-tech-bg: hsl(150, 50%, 20%);
  --tag-tech-text: hsl(150, 60%, 80%);
  --tag-nontech-bg: hsl(281, 18%, 76%);
  --tag-nontech-text: hsl(280, 50%, 80%);

  /* Gradients - adjusted for dark */
  --gradient-card: linear-gradient(145deg, hsl(222, 47%, 13%) 0%, hsl(222, 47%, 11%) 100%);
}

/* =========================================
   BASE STYLES & RESETS
   ========================================= */
* {
  box-sizing: border-box;
}

/* Scoped to profile page to avoid polluting global fonts on Home */
.profile-page {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* =========================================
   PROFILE COMPONENT STYLES
   ========================================= */

/* Main container */
.profile-page {
  min-height: 100vh;
  background: var(--profile-bg);
  padding-bottom: 6rem;
}

.profile-page.is-editing {
  background: linear-gradient(180deg, var(--edit-bg) 0%, var(--profile-bg) 100%);
}

.profile-page.loading {
  display: flex;
  align-items: center;
  justify-content: center;
}

.gradient-text {
  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.profile-avatar-inner {
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease;
}

.profile-avatar-wrap:hover .profile-avatar-inner {
  transform: scale(1.05);
  box-shadow: 0 0 20px -5px var(--primary);
}

/* Header */
.profile-header {
  background: var(--gradient-hero);
  padding: 1.5rem 1rem 2rem;
  position: relative;
  overflow: hidden;
}

.profile-header::before {
  content: '';
  position: absolute;
  inset: 0;
  /* Purple and Pink accents from Home page */
  background: radial-gradient(circle at 30% 70%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 70% 30%, rgba(255, 119, 198, 0.2) 0%, transparent 40%);
  pointer-events: none;
}

.profile-header-content {
  max-width: 980px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.profile-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: white;
  letter-spacing: -0.025em;
  text-align: center;
  margin-bottom: 1rem;
}

.profile-title-text {
  background: linear-gradient(135deg, white 0%, hsl(38, 92%, 70%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profile-controls {
  display: flex;
  justify-content: center;
}

/* Edit/Save toggle button */
.profile-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 700;
  font-size: 0.875rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  cursor: pointer;
}

.profile-toggle-btn.view-mode {
  background: var(--gradient-button);
  color: var(--foreground);
  box-shadow: 0 4px 15px -3px hsla(38, 92%, 50%, 0.4);
}

.profile-toggle-btn.view-mode:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px -3px hsla(38, 92%, 50%, 0.5);
}

.profile-toggle-btn.edit-mode {
  background: linear-gradient(135deg, hsl(150, 70%, 40%) 0%, hsl(160, 65%, 35%) 100%);
  color: white;
  box-shadow: 0 4px 15px -3px hsla(150, 70%, 40%, 0.4);
}

.profile-toggle-btn.edit-mode:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px -3px hsla(150, 70%, 40%, 0.5);
}

/* Tabs */
.profile-tabs {
  display: flex;
  gap: 0.375rem;
  padding: 0.5rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: var(--profile-card);
  border-radius: 1rem;
  box-shadow: var(--shadow-md);
  margin: -1.5rem 1rem 1.5rem;
  position: relative;
  z-index: 10;
  justify-content: flex-start;
  /* Ensure tabs start from left on mobile */
}

@media (min-width: 640px) {
  .profile-tabs {
    justify-content: center;
    max-width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
}

.profile-tabs::-webkit-scrollbar {
  display: none;
}

.profile-tab {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.625rem 1rem;
  border-radius: 0.625rem;
  font-weight: 600;
  font-size: 0.8125rem;
  white-space: nowrap;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  cursor: pointer;
  background: transparent;
  color: var(--profile-muted);
}

.profile-tab:hover {
  background: var(--muted);
  color: var(--profile-text);
}

.profile-tab.active {
  background: var(--gradient-tab-active);
  color: white;
  box-shadow: 0 4px 12px -2px hsla(197, 71%, 28%, 0.35);
}

.profile-tab svg {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.profile-tab-label {
  display: none;
}

@media (min-width: 640px) {
  .profile-tab-label {
    display: inline;
  }
}

/* Cards */
.profile-card {
  background: var(--profile-card);
  border-radius: var(--radius);
  padding: 1.25rem;
  box-shadow: var(--shadow-card);
  transition: all 0.25s ease;
}

.is-editing .profile-card {
  background: var(--gradient-edit);
  box-shadow: var(--shadow-edit);
  border: 1px solid hsla(38, 70%, 75%, 0.5);
  /* using variable manually */
}

.profile-card-header {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 1rem;
  color: var(--profile-heading);
  font-size: 1.0625rem;
  font-weight: 700;
}

.profile-card-header svg {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--primary);
}

/* Container */
.profile-container {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Avatar Section */
.profile-avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: var(--profile-card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-card);
}

.is-editing .profile-avatar-section {
  background: var(--gradient-edit);
  box-shadow: var(--shadow-edit);
}

.profile-avatar-wrap {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);
  padding: 4px;
  box-shadow: 0 8px 25px -5px hsla(197, 71%, 28%, 0.3);
}

.profile-avatar-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--profile-card);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.profile-avatar-inner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-avatar-initial {
  font-size: 2rem;
  font-weight: 700;
  color: var(--profile-muted);
}

.profile-avatar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
}

/* Buttons */
.btn-profile {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  border-radius: 0.625rem;
  font-weight: 600;
  font-size: 0.8125rem;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}

.btn-profile-secondary {
  background: var(--muted);
  color: var(--profile-text);
}

.btn-profile-secondary:hover {
  background: var(--border);
}

.btn-profile-primary {
  background: var(--primary);
  color: var(--primary-foreground);
}

.btn-profile-primary:hover {
  filter: brightness(1.1);
}

.btn-profile-danger {
  background: var(--destructive);
  color: var(--destructive-foreground);
}

.btn-profile-danger:hover {
  filter: brightness(1.1);
}

.btn-profile-accent {
  background: var(--gradient-button);
  color: var(--foreground);
  box-shadow: 0 2px 8px -2px hsla(38, 92%, 50%, 0.3);
}

.btn-profile-accent:hover {
  filter: brightness(1.05);
  box-shadow: 0 4px 12px -2px hsla(38, 92%, 50%, 0.4);
}

.btn-profile:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Form grid */
.profile-form-grid {
  display: grid;
  gap: 1rem;
}

@media (min-width: 640px) {
  .profile-form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.profile-form-row {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.profile-form-row.full-width {
  grid-column: 1 / -1;
}

/* Vertical stacking for form rows in read mode */
.profile-page:not(.is-editing) .profile-form-row {
  gap: 0.125rem;
  margin-bottom: 0.5rem;
}

.profile-label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--profile-heading);
  transition: all 0.2s ease;
}

/* Modern Minimalist Labels in Read Mode */
.profile-page:not(.is-editing) .profile-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--profile-muted);
  font-weight: 700;
}

.profile-input,
.profile-textarea,
.profile-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.625rem;
  border: 1.5px solid var(--profile-border);
  background: var(--profile-card);
  font-size: 0.9375rem;
  color: var(--profile-text);
  transition: all 0.2s ease;
}

.profile-input:focus,
.profile-textarea:focus,
.profile-select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px hsla(197, 71%, 28%, 0.1);
}

.is-editing .profile-input,
.is-editing .profile-textarea,
.is-editing .profile-select {
  background: var(--edit-input-bg);
  border-color: var(--edit-border);
}

.is-editing .profile-input:focus,
.is-editing .profile-textarea:focus,
.is-editing .profile-select:focus {
  border-color: var(--edit-accent);
  box-shadow: 0 0 0 3px hsla(38, 92%, 50%, 0.15);
}

/* Modern Minimalist Values in Read Mode */
.profile-page:not(.is-editing) .profile-input:disabled,
.profile-page:not(.is-editing) .profile-textarea:disabled,
.profile-page:not(.is-editing) .profile-select:disabled {
  background: transparent;
  color: var(--profile-heading);
  cursor: default;
  border-color: transparent;
  padding: 0;
  box-shadow: none;
  font-size: 1.1rem;
  font-weight: 700;
  opacity: 1;
  appearance: none;
  min-height: auto;
}

.profile-page:not(.is-editing) .profile-textarea:disabled {
  resize: none;
  line-height: 1.6;
}

/* Scrollable text areas for Bio and Aspirations */
.profile-textarea-scrollable {
  min-height: calc(1.6em * 4 + 1.5rem); /* approx 4 lines + padding */
  max-height: calc(1.6em * 4 + 1.5rem);
  overflow-y: auto;
}

.profile-page:not(.is-editing) .profile-textarea-scrollable:disabled {
  min-height: calc(1.6em * 4);
  max-height: calc(1.6em * 4);
  overflow-y: auto;
  padding-right: 0.5rem; /* space for scrollbar */
}

/* Custom scrollbar for text areas */
.profile-textarea-scrollable::-webkit-scrollbar {
  width: 6px;
}
.profile-textarea-scrollable::-webkit-scrollbar-track {
  background: transparent;
}
.profile-textarea-scrollable::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 10px;
}
.profile-textarea-scrollable:hover::-webkit-scrollbar-thumb {
  background: var(--profile-muted);
}

/* Highlighted role in work tab */
.profile-role-highlight {
  background-color: hsla(197, 71%, 28%, 0.1);
  color: var(--primary);
  border: 1px solid hsla(197, 71%, 28%, 0.2);
  padding: 0.2rem 0.6rem;
  border-radius: 0.4rem;
  display: inline-block;
  font-weight: 700;
  margin-right: 0.5rem;
}

html.dark .profile-role-highlight {
  background-color: hsla(197, 71%, 60%, 0.15);
  color: hsl(197, 71%, 70%);
  border-color: hsla(197, 71%, 60%, 0.25);
}

/* View mode text display */
.profile-view-text {
  font-size: 0.9375rem;
  color: var(--view-text);
  line-height: 1.6;
}

.profile-view-empty {
  font-size: 0.875rem;
  color: var(--profile-muted);
  font-style: italic;
}

/* Tags */
.profile-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.profile-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  background: var(--tag-bg);
  color: var(--tag-text);
}

.profile-tag-tech {
  background: var(--tag-tech-bg);
  color: var(--tag-tech-text);
}

.profile-tag-nontech {
  background: var(--tag-nontech-bg);
  color: var(--tag-nontech-text);
}

.profile-tag-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  background: var(--destructive);
  color: white;
  font-size: 0.875rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  margin-left: 0.25rem;
  transition: transform 0.15s ease;
}

.profile-tag-remove:hover {
  transform: scale(1.1);
}

/* Add item row */
.profile-add-row {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.profile-add-row input {
  flex: 1 1;
}

/* Cards list items */
.profile-list-item {
  padding: 1rem;
  border-radius: 0.625rem;
  background: hsla(220, 14%, 96%, 0.5);
  margin-bottom: 0.75rem;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
}

.profile-list-item:hover {
  transform: translateY(-2px) scale(1.01);
  background: var(--profile-card);
  box-shadow: var(--shadow-md);
  border-color: var(--border);
}

html.dark .profile-list-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--border);
}

html.dark .profile-list-item:hover {
  background: rgba(255, 255, 255, 0.08);
  /* Darker hover state for dark mode */
  border-color: var(--primary);
}

.is-editing .profile-list-item {
  background: var(--profile-card);
  border: 1px solid var(--profile-border);
}

.profile-list-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
}

.profile-list-item-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--profile-heading);
  margin: 0;
}

.profile-list-item-badge {
  display: inline-flex;
  padding: 0.25rem 0.625rem;
  border-radius: 999px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.profile-list-item-badge.success {
  background: var(--badge-success-bg);
  color: var(--badge-success-text);
}

.profile-list-item-badge.warning {
  background: var(--badge-warning-bg);
  color: var(--badge-warning-text);
}

.profile-list-item-badge.info {
  background: var(--badge-info-bg);
  color: var(--badge-info-text);
}

.profile-list-item-text {
  font-size: 0.875rem;
  color: var(--profile-text);
  margin: 0.5rem 0 0;
  line-height: 1.5;
}

.profile-list-item-meta {
  font-size: 0.8125rem;
  color: var(--profile-muted);
  margin-top: 0.25rem;
}

/* Links */
.profile-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--view-accent);
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: none;
  transition: color 0.15s ease;
}

.profile-link:hover {
  color: var(--primary);
  text-decoration: underline;
}

.profile-link-gold {
  color: var(--accent);
}

.profile-link-gold:hover {
  color: hsl(28, 90%, 48%);
}

/* New item form */
.profile-new-item-form {
  padding: 1rem;
  border: 2px dashed var(--profile-border);
  border-radius: 0.625rem;
  background: hsla(220, 14%, 96%, 0.3);
}

.is-editing .profile-new-item-form {
  border-color: var(--edit-border);
  background: var(--edit-input-bg);
}

.profile-new-item-form .profile-form-grid {
  gap: 0.75rem;
}

/* Verified badge */
.verified-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 0.375rem;
}

/* Name display */
.profile-name-display {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--profile-heading);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.profile-info-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.profile-info-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  color: var(--profile-text);
}

.profile-info-item svg {
  width: 1rem;
  height: 1rem;
  color: var(--profile-muted);
}

/* Utilities for React Transition Group or Framer Motion */
.profile-animate-in {
  animation: fadeInMoveUp 0.3s ease-out forwards;
}

@keyframes fadeInMoveUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Tailwind-ish Utilities Replacements */
.text-center {
  text-align: center;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.w-full {
  width: 100%;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.overflow-hidden {
  overflow: hidden;
}

/* =========================================
   SKELETON COMPONENT STYLES
   ========================================= */
.profile-page-wrapper.skeleton-mode {
  pointer-events: none;
  min-height: 100vh;
  background: var(--profile-bg);
  padding: 1.5rem 1rem;
}

.skeleton-pulse {
  background: linear-gradient(90deg,
      var(--muted) 25%,
      var(--border) 50%,
      var(--muted) 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite linear;
  border-radius: var(--radius);
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.skeleton-title {
  height: 2.5rem;
  width: 15rem;
  margin: 0 auto 2rem;
  border-radius: 999px;
  opacity: 0.5;
}

.skeleton-header-card {
  height: 10rem;
  width: 100%;
  max-width: 980px;
  margin: 0 auto 1.5rem;
}

.skeleton-tabs {
  height: 4rem;
  width: 100%;
  max-width: 980px;
  margin: 0 auto 1.5rem;
  border-radius: 1rem;
}

.skeleton-avatar-card {
  height: 20rem;
  width: 100%;
  margin-bottom: 1rem;
}

.skeleton-info-card {
  height: 30rem;
  width: 100%;
}

.personal-container {
  display: grid;
  gap: 1.5rem;
  max-width: 980px;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .personal-container {
    grid-template-columns: 280px 1fr;
  }
}

/* Image Modal */
.cursor-zoom-in {
  cursor: zoom-in;
}

.profile-image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.profile-image-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  background: transparent;
}

.profile-full-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 0.5rem;
  display: block;
}

.profile-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.profile-modal-close:hover {
  background: white;
  color: black;
  transform: rotate(90deg);
}

/* Problem Statement Items */
.problem-statement-item {
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid transparent;
  /* Default transparent border */
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.03);
  /* Default dark mode bg */
  position: relative;
  margin-bottom: 0.5rem;
}

[data-theme='light'] .problem-statement-item {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  /* Visible border in light mode */
  color: #212529;
}

.problem-statement-item:hover {
  border-color: #22c55e;
  /* Green border on hover */
  background: rgba(34, 197, 94, 0.05);
  /* Slight green tint */
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.1);
}

[data-theme='light'] .problem-statement-item:hover {
  background: #f0fff4;
  /* Light green in light mode */
  border-color: #22c55e;
}

.problem-statement-item.selected {
  background: rgba(34, 197, 94, 0.15);
  border-color: #22c55e;
  box-shadow: 0 0 0 1px #22c55e;
  /* Highlight selected */
}

[data-theme='light'] .problem-statement-item.selected {
  background: #dcffe4;
  border-color: #16a34a;
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile.css"],"names":[],"mappings":"AAAA;;8CAE8C;;AAE9C;EACE,8DAA8D;EAC9D,+BAA+B;EAC/B,gCAAgC;;EAEhC,wBAAwB;EACxB,qCAAqC;;EAErC,2BAA2B;EAC3B,wCAAwC;;EAExC,8BAA8B;EAC9B,6BAA6B;EAC7B,sCAAsC;;EAEtC,0BAA0B;EAC1B,8BAA8B;EAC9B,0CAA0C;;EAE1C,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;;EAErC,6BAA6B;EAC7B,2BAA2B;EAC3B,uCAAuC;;EAEvC,gBAAgB;EAChB,+BAA+B;EAC/B,0CAA0C;;EAE1C,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;;EAE1B,cAAc;;EAEd,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,kCAAkC;EAClC,oCAAoC;;EAEpC,iCAAiC;EACjC,4BAA4B;EAC5B,gCAAgC;EAChC,gCAAgC;EAChC,kCAAkC;;EAElC,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,iCAAiC;;EAEjC,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,sCAAsC;;EAEtC,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,qCAAqC;EACrC,uCAAuC;EACvC,mCAAmC;EACnC,qCAAqC;;EAErC,cAAc;EACd,wDAAwD;EACxD,+EAA+E;EAC/E,qFAAqF;EACrF,sFAAsF;EACtF,wFAAwF;EACxF,wEAAwE;EACxE,uCAAuC;;EAEvC,YAAY;EACZ,iDAAiD;EACjD,8FAA8F;EAC9F,+FAA+F;EAC/F,uDAAuD;EACvD,sDAAsD;AACxD;;AAEA;;8CAE8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA,8FAA8F;AAC9F;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,gCAAgC;EAChC,+BAA+B;;EAE/B,0BAA0B;EAC1B,oCAAoC;;EAEpC,6BAA6B;EAC7B,8CAA8C;EAC9C,sCAAsC;;EAEtC,2BAA2B;EAC3B,sCAAsC;;EAEtC,4BAA4B;EAC5B,2BAA2B;;EAE3B,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;;EAEpC,cAAc;EACd,6BAA6B;EAC7B,gCAAgC;EAChC,mCAAmC;EACnC,wFAAwF;EACxF,iDAAiD;;EAEjD,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;;EAE/B,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,sCAAsC;;EAEtC,kCAAkC;EAClC,wFAAwF;AAC1F;;AAEA;;8CAE8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,uGAAuG;AACzG;;AAEA;;8CAE8C;;AAE9C,mBAAmB;AACnB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C;oFACkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qEAAqE;EACrE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,mFAAmF;EACnF,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kDAAkD;EAClD,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;EACzC,+BAA+B;EAC/B,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;;;EAGE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;;;EAGE,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EAGV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,oCAAoC,EAAE,6BAA6B;EACnE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB,EAAE,wBAAwB;AACjD;;AAEA,oCAAoC;AACpC;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,0CAA0C;EAC1C,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,sBAAsB;EACtB,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,wCAAwC;EACxC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;8CAE8C;AAC9C;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;;;uBAGqB;EACrB,0BAA0B;EAC1B,gDAAgD;EAChD,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":["/* =========================================\n   DESIGN SYSTEM - Lovable Profile\n   ========================================= */\n\n:root {\n  /* Core palette - Sophisticated slate-navy with warm accents */\n  --background: hsl(40, 30%, 98%);\n  --foreground: hsl(222, 47%, 11%);\n\n  --card: hsl(0, 0%, 100%);\n  --card-foreground: hsl(222, 47%, 11%);\n\n  --popover: hsl(0, 0%, 100%);\n  --popover-foreground: hsl(222, 47%, 11%);\n\n  /* Primary - Deep ocean teal */\n  --primary: hsl(197, 71%, 28%);\n  --primary-foreground: hsl(0, 0%, 100%);\n\n  /* Secondary - Warm sand */\n  --secondary: hsl(40, 30%, 96%);\n  --secondary-foreground: hsl(222, 47%, 11%);\n\n  /* Muted - Soft gray-lavender */\n  --muted: hsl(220, 14%, 96%);\n  --muted-foreground: hsl(220, 9%, 46%);\n\n  /* Accent - Rich amber/gold */\n  --accent: hsl(38, 92%, 50%);\n  --accent-foreground: hsl(222, 47%, 11%);\n\n  /* Destructive */\n  --destructive: hsl(0, 84%, 60%);\n  --destructive-foreground: hsl(0, 0%, 100%);\n\n  /* Borders & inputs */\n  --border: hsl(220, 13%, 91%);\n  --input: hsl(220, 13%, 91%);\n  --ring: hsl(197, 71%, 28%);\n\n  --radius: 1rem;\n\n  /* Custom profile-specific tokens */\n  --profile-bg: hsl(40, 30%, 98%);\n  --profile-card: hsl(0, 0%, 100%);\n  --profile-heading: hsl(222, 47%, 15%);\n  --profile-text: hsl(222, 32%, 20%);\n  --profile-muted: hsl(220, 9%, 46%);\n  --profile-border: hsl(220, 20%, 90%);\n\n  /* Edit mode - warm amber tints */\n  --edit-bg: hsl(45, 60%, 97%);\n  --edit-border: hsl(38, 70%, 75%);\n  --edit-accent: hsl(38, 92%, 50%);\n  --edit-input-bg: hsl(45, 50%, 99%);\n\n  /* View mode - clean, elegant */\n  --view-bg: hsl(0, 0%, 100%);\n  --view-text: hsl(222, 32%, 25%);\n  --view-accent: hsl(197, 71%, 35%);\n\n  /* Tag/pill colors */\n  --tag-bg: hsl(197, 50%, 95%);\n  --tag-text: hsl(197, 71%, 28%);\n  --tag-tech-bg: hsl(150, 50%, 95%);\n  --tag-tech-text: hsl(150, 60%, 30%);\n  --tag-nontech-bg: hsl(280, 40%, 96%);\n  --tag-nontech-text: hsl(280, 50%, 40%);\n\n  /* Status badges */\n  --badge-success-bg: hsl(150, 60%, 94%);\n  --badge-success-text: hsl(150, 70%, 28%);\n  --badge-warning-bg: hsl(45, 90%, 94%);\n  --badge-warning-text: hsl(25, 80%, 35%);\n  --badge-info-bg: hsl(200, 70%, 94%);\n  --badge-info-text: hsl(200, 80%, 30%);\n\n  /* Gradients */\n  /* Matched to Home page: #0f0f23 -> #1a1a2e -> #16213e */\n  --gradient-hero: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);\n  --gradient-card: linear-gradient(145deg, hsl(0, 0%, 100%) 0%, hsl(40, 30%, 98%) 100%);\n  --gradient-edit: linear-gradient(145deg, hsl(45, 60%, 98%) 0%, hsl(38, 70%, 96%) 100%);\n  --gradient-button: linear-gradient(135deg, hsl(38, 92%, 50%) 0%, hsl(28, 90%, 48%) 100%);\n  --gradient-tab-active: linear-gradient(135deg, #1a1a2e 0%, #2a2a4e 100%);\n  /* Adjusted active tab to match theme */\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 hsl(220, 13%, 11%, 0.03);\n  --shadow-md: 0 4px 12px -1px hsl(220, 13%, 11%, 0.06), 0 2px 4px -2px hsl(220, 13%, 11%, 0.04);\n  --shadow-lg: 0 10px 30px -4px hsl(220, 13%, 11%, 0.08), 0 4px 6px -4px hsl(220, 13%, 11%, 0.04);\n  --shadow-card: 0 4px 20px -4px hsl(220, 13%, 11%, 0.07);\n  --shadow-edit: 0 4px 20px -4px hsl(38, 92%, 50%, 0.15);\n}\n\n/* =========================================\n   BASE STYLES & RESETS\n   ========================================= */\n* {\n  box-sizing: border-box;\n}\n\n/* Fix for full screen: Reset body margin/padding which might be missing after Home unmounts */\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  background-color: var(--profile-bg);\n  /* Prevent white edges during load */\n}\n\n/* Dark Mode Variables */\n[data-theme='dark'] {\n  --background: hsl(222, 47%, 11%);\n  --foreground: hsl(40, 30%, 98%);\n\n  --card: hsl(222, 47%, 13%);\n  --card-foreground: hsl(40, 30%, 98%);\n\n  --primary: hsl(197, 71%, 40%);\n  /* Slightly lighter for dark mode visibility */\n  --primary-foreground: hsl(0, 0%, 100%);\n\n  --muted: hsl(217, 33%, 17%);\n  --muted-foreground: hsl(215, 20%, 65%);\n\n  --border: hsl(217, 33%, 20%);\n  --input: hsl(217, 33%, 20%);\n\n  /* Profile specific overrides */\n  --profile-bg: hsl(222, 47%, 10%);\n  --profile-card: hsl(222, 47%, 13%);\n  --profile-heading: hsl(40, 30%, 98%);\n  --profile-text: hsl(215, 20%, 85%);\n  --profile-muted: hsl(215, 20%, 65%);\n  --profile-border: hsl(217, 33%, 20%);\n\n  /* Edit mode */\n  --edit-bg: hsl(222, 47%, 12%);\n  --edit-border: hsl(38, 70%, 40%);\n  --edit-input-bg: hsl(222, 47%, 15%);\n  --gradient-edit: linear-gradient(145deg, hsl(222, 47%, 14%) 0%, hsl(222, 47%, 10%) 100%);\n  --shadow-edit: 0 8px 30px -4px rgba(0, 0, 0, 0.4);\n\n  /* View mode */\n  --view-bg: hsl(222, 47%, 13%);\n  --view-text: hsl(215, 20%, 85%);\n\n  /* Tags */\n  --tag-bg: hsl(197, 50%, 20%);\n  --tag-text: hsl(197, 71%, 80%);\n  --tag-tech-bg: hsl(150, 50%, 20%);\n  --tag-tech-text: hsl(150, 60%, 80%);\n  --tag-nontech-bg: hsl(281, 18%, 76%);\n  --tag-nontech-text: hsl(280, 50%, 80%);\n\n  /* Gradients - adjusted for dark */\n  --gradient-card: linear-gradient(145deg, hsl(222, 47%, 13%) 0%, hsl(222, 47%, 11%) 100%);\n}\n\n/* =========================================\n   BASE STYLES & RESETS\n   ========================================= */\n* {\n  box-sizing: border-box;\n}\n\n/* Scoped to profile page to avoid polluting global fonts on Home */\n.profile-page {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n/* =========================================\n   PROFILE COMPONENT STYLES\n   ========================================= */\n\n/* Main container */\n.profile-page {\n  min-height: 100vh;\n  background: var(--profile-bg);\n  padding-bottom: 6rem;\n}\n\n.profile-page.is-editing {\n  background: linear-gradient(180deg, var(--edit-bg) 0%, var(--profile-bg) 100%);\n}\n\n.profile-page.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n}\n\n.profile-avatar-inner {\n  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.3s ease;\n}\n\n.profile-avatar-wrap:hover .profile-avatar-inner {\n  transform: scale(1.05);\n  box-shadow: 0 0 20px -5px var(--primary);\n}\n\n/* Header */\n.profile-header {\n  background: var(--gradient-hero);\n  padding: 1.5rem 1rem 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.profile-header::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  /* Purple and Pink accents from Home page */\n  background: radial-gradient(circle at 30% 70%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),\n    radial-gradient(circle at 70% 30%, rgba(255, 119, 198, 0.2) 0%, transparent 40%);\n  pointer-events: none;\n}\n\n.profile-header-content {\n  max-width: 980px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.profile-title {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: white;\n  letter-spacing: -0.025em;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.profile-title-text {\n  background: linear-gradient(135deg, white 0%, hsl(38, 92%, 70%) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profile-controls {\n  display: flex;\n  justify-content: center;\n}\n\n/* Edit/Save toggle button */\n.profile-toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.75rem;\n  font-weight: 700;\n  font-size: 0.875rem;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  border: none;\n  cursor: pointer;\n}\n\n.profile-toggle-btn.view-mode {\n  background: var(--gradient-button);\n  color: var(--foreground);\n  box-shadow: 0 4px 15px -3px hsla(38, 92%, 50%, 0.4);\n}\n\n.profile-toggle-btn.view-mode:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px -3px hsla(38, 92%, 50%, 0.5);\n}\n\n.profile-toggle-btn.edit-mode {\n  background: linear-gradient(135deg, hsl(150, 70%, 40%) 0%, hsl(160, 65%, 35%) 100%);\n  color: white;\n  box-shadow: 0 4px 15px -3px hsla(150, 70%, 40%, 0.4);\n}\n\n.profile-toggle-btn.edit-mode:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px -3px hsla(150, 70%, 40%, 0.5);\n}\n\n/* Tabs */\n.profile-tabs {\n  display: flex;\n  gap: 0.375rem;\n  padding: 0.5rem;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  background: var(--profile-card);\n  border-radius: 1rem;\n  box-shadow: var(--shadow-md);\n  margin: -1.5rem 1rem 1.5rem;\n  position: relative;\n  z-index: 10;\n  justify-content: flex-start;\n  /* Ensure tabs start from left on mobile */\n}\n\n@media (min-width: 640px) {\n  .profile-tabs {\n    justify-content: center;\n    max-width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n.profile-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.profile-tab {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.625rem 1rem;\n  border-radius: 0.625rem;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  white-space: nowrap;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: var(--profile-muted);\n}\n\n.profile-tab:hover {\n  background: var(--muted);\n  color: var(--profile-text);\n}\n\n.profile-tab.active {\n  background: var(--gradient-tab-active);\n  color: white;\n  box-shadow: 0 4px 12px -2px hsla(197, 71%, 28%, 0.35);\n}\n\n.profile-tab svg {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n.profile-tab-label {\n  display: none;\n}\n\n@media (min-width: 640px) {\n  .profile-tab-label {\n    display: inline;\n  }\n}\n\n/* Cards */\n.profile-card {\n  background: var(--profile-card);\n  border-radius: var(--radius);\n  padding: 1.25rem;\n  box-shadow: var(--shadow-card);\n  transition: all 0.25s ease;\n}\n\n.is-editing .profile-card {\n  background: var(--gradient-edit);\n  box-shadow: var(--shadow-edit);\n  border: 1px solid hsla(38, 70%, 75%, 0.5);\n  /* using variable manually */\n}\n\n.profile-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  margin-bottom: 1rem;\n  color: var(--profile-heading);\n  font-size: 1.0625rem;\n  font-weight: 700;\n}\n\n.profile-card-header svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--primary);\n}\n\n/* Container */\n.profile-container {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 0 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* Avatar Section */\n.profile-avatar-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  background: var(--profile-card);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-card);\n}\n\n.is-editing .profile-avatar-section {\n  background: var(--gradient-edit);\n  box-shadow: var(--shadow-edit);\n}\n\n.profile-avatar-wrap {\n  width: 7rem;\n  height: 7rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%);\n  padding: 4px;\n  box-shadow: 0 8px 25px -5px hsla(197, 71%, 28%, 0.3);\n}\n\n.profile-avatar-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: var(--profile-card);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.profile-avatar-inner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.profile-avatar-initial {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--profile-muted);\n}\n\n.profile-avatar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n/* Buttons */\n.btn-profile {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.625rem;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  transition: all 0.2s ease;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-profile-secondary {\n  background: var(--muted);\n  color: var(--profile-text);\n}\n\n.btn-profile-secondary:hover {\n  background: var(--border);\n}\n\n.btn-profile-primary {\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.btn-profile-primary:hover {\n  filter: brightness(1.1);\n}\n\n.btn-profile-danger {\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n}\n\n.btn-profile-danger:hover {\n  filter: brightness(1.1);\n}\n\n.btn-profile-accent {\n  background: var(--gradient-button);\n  color: var(--foreground);\n  box-shadow: 0 2px 8px -2px hsla(38, 92%, 50%, 0.3);\n}\n\n.btn-profile-accent:hover {\n  filter: brightness(1.05);\n  box-shadow: 0 4px 12px -2px hsla(38, 92%, 50%, 0.4);\n}\n\n.btn-profile:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Form grid */\n.profile-form-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n@media (min-width: 640px) {\n  .profile-form-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.profile-form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.profile-form-row.full-width {\n  grid-column: 1 / -1;\n}\n\n/* Vertical stacking for form rows in read mode */\n.profile-page:not(.is-editing) .profile-form-row {\n  gap: 0.125rem;\n  margin-bottom: 0.5rem;\n}\n\n.profile-label {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--profile-heading);\n  transition: all 0.2s ease;\n}\n\n/* Modern Minimalist Labels in Read Mode */\n.profile-page:not(.is-editing) .profile-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--profile-muted);\n  font-weight: 700;\n}\n\n.profile-input,\n.profile-textarea,\n.profile-select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border-radius: 0.625rem;\n  border: 1.5px solid var(--profile-border);\n  background: var(--profile-card);\n  font-size: 0.9375rem;\n  color: var(--profile-text);\n  transition: all 0.2s ease;\n}\n\n.profile-input:focus,\n.profile-textarea:focus,\n.profile-select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px hsla(197, 71%, 28%, 0.1);\n}\n\n.is-editing .profile-input,\n.is-editing .profile-textarea,\n.is-editing .profile-select {\n  background: var(--edit-input-bg);\n  border-color: var(--edit-border);\n}\n\n.is-editing .profile-input:focus,\n.is-editing .profile-textarea:focus,\n.is-editing .profile-select:focus {\n  border-color: var(--edit-accent);\n  box-shadow: 0 0 0 3px hsla(38, 92%, 50%, 0.15);\n}\n\n/* Modern Minimalist Values in Read Mode */\n.profile-page:not(.is-editing) .profile-input:disabled,\n.profile-page:not(.is-editing) .profile-textarea:disabled,\n.profile-page:not(.is-editing) .profile-select:disabled {\n  background: transparent;\n  color: var(--profile-heading);\n  cursor: default;\n  border-color: transparent;\n  padding: 0;\n  box-shadow: none;\n  font-size: 1.1rem;\n  font-weight: 700;\n  opacity: 1;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  min-height: auto;\n}\n\n.profile-page:not(.is-editing) .profile-textarea:disabled {\n  resize: none;\n  line-height: 1.6;\n}\n\n/* Scrollable text areas for Bio and Aspirations */\n.profile-textarea-scrollable {\n  min-height: calc(1.6em * 4 + 1.5rem); /* approx 4 lines + padding */\n  max-height: calc(1.6em * 4 + 1.5rem);\n  overflow-y: auto;\n}\n\n.profile-page:not(.is-editing) .profile-textarea-scrollable:disabled {\n  min-height: calc(1.6em * 4);\n  max-height: calc(1.6em * 4);\n  overflow-y: auto;\n  padding-right: 0.5rem; /* space for scrollbar */\n}\n\n/* Custom scrollbar for text areas */\n.profile-textarea-scrollable::-webkit-scrollbar {\n  width: 6px;\n}\n.profile-textarea-scrollable::-webkit-scrollbar-track {\n  background: transparent;\n}\n.profile-textarea-scrollable::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 10px;\n}\n.profile-textarea-scrollable:hover::-webkit-scrollbar-thumb {\n  background: var(--profile-muted);\n}\n\n/* Highlighted role in work tab */\n.profile-role-highlight {\n  background-color: hsla(197, 71%, 28%, 0.1);\n  color: var(--primary);\n  border: 1px solid hsla(197, 71%, 28%, 0.2);\n  padding: 0.2rem 0.6rem;\n  border-radius: 0.4rem;\n  display: inline-block;\n  font-weight: 700;\n  margin-right: 0.5rem;\n}\n\nhtml.dark .profile-role-highlight {\n  background-color: hsla(197, 71%, 60%, 0.15);\n  color: hsl(197, 71%, 70%);\n  border-color: hsla(197, 71%, 60%, 0.25);\n}\n\n/* View mode text display */\n.profile-view-text {\n  font-size: 0.9375rem;\n  color: var(--view-text);\n  line-height: 1.6;\n}\n\n.profile-view-empty {\n  font-size: 0.875rem;\n  color: var(--profile-muted);\n  font-style: italic;\n}\n\n/* Tags */\n.profile-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.profile-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  background: var(--tag-bg);\n  color: var(--tag-text);\n}\n\n.profile-tag-tech {\n  background: var(--tag-tech-bg);\n  color: var(--tag-tech-text);\n}\n\n.profile-tag-nontech {\n  background: var(--tag-nontech-bg);\n  color: var(--tag-nontech-text);\n}\n\n.profile-tag-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  height: 1.25rem;\n  border-radius: 50%;\n  background: var(--destructive);\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  margin-left: 0.25rem;\n  transition: transform 0.15s ease;\n}\n\n.profile-tag-remove:hover {\n  transform: scale(1.1);\n}\n\n/* Add item row */\n.profile-add-row {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n}\n\n.profile-add-row input {\n  flex: 1;\n}\n\n/* Cards list items */\n.profile-list-item {\n  padding: 1rem;\n  border-radius: 0.625rem;\n  background: hsla(220, 14%, 96%, 0.5);\n  margin-bottom: 0.75rem;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 1px solid transparent;\n}\n\n.profile-list-item:hover {\n  transform: translateY(-2px) scale(1.01);\n  background: var(--profile-card);\n  box-shadow: var(--shadow-md);\n  border-color: var(--border);\n}\n\nhtml.dark .profile-list-item {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--border);\n}\n\nhtml.dark .profile-list-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  /* Darker hover state for dark mode */\n  border-color: var(--primary);\n}\n\n.is-editing .profile-list-item {\n  background: var(--profile-card);\n  border: 1px solid var(--profile-border);\n}\n\n.profile-list-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.profile-list-item-title {\n  font-size: 0.9375rem;\n  font-weight: 700;\n  color: var(--profile-heading);\n  margin: 0;\n}\n\n.profile-list-item-badge {\n  display: inline-flex;\n  padding: 0.25rem 0.625rem;\n  border-radius: 999px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.profile-list-item-badge.success {\n  background: var(--badge-success-bg);\n  color: var(--badge-success-text);\n}\n\n.profile-list-item-badge.warning {\n  background: var(--badge-warning-bg);\n  color: var(--badge-warning-text);\n}\n\n.profile-list-item-badge.info {\n  background: var(--badge-info-bg);\n  color: var(--badge-info-text);\n}\n\n.profile-list-item-text {\n  font-size: 0.875rem;\n  color: var(--profile-text);\n  margin: 0.5rem 0 0;\n  line-height: 1.5;\n}\n\n.profile-list-item-meta {\n  font-size: 0.8125rem;\n  color: var(--profile-muted);\n  margin-top: 0.25rem;\n}\n\n/* Links */\n.profile-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  color: var(--view-accent);\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.profile-link:hover {\n  color: var(--primary);\n  text-decoration: underline;\n}\n\n.profile-link-gold {\n  color: var(--accent);\n}\n\n.profile-link-gold:hover {\n  color: hsl(28, 90%, 48%);\n}\n\n/* New item form */\n.profile-new-item-form {\n  padding: 1rem;\n  border: 2px dashed var(--profile-border);\n  border-radius: 0.625rem;\n  background: hsla(220, 14%, 96%, 0.3);\n}\n\n.is-editing .profile-new-item-form {\n  border-color: var(--edit-border);\n  background: var(--edit-input-bg);\n}\n\n.profile-new-item-form .profile-form-grid {\n  gap: 0.75rem;\n}\n\n/* Verified badge */\n.verified-badge {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 0.375rem;\n}\n\n/* Name display */\n.profile-name-display {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--profile-heading);\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.profile-info-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.profile-info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.875rem;\n  color: var(--profile-text);\n}\n\n.profile-info-item svg {\n  width: 1rem;\n  height: 1rem;\n  color: var(--profile-muted);\n}\n\n/* Utilities for React Transition Group or Framer Motion */\n.profile-animate-in {\n  animation: fadeInMoveUp 0.3s ease-out forwards;\n}\n\n@keyframes fadeInMoveUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Tailwind-ish Utilities Replacements */\n.text-center {\n  text-align: center;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n/* =========================================\n   SKELETON COMPONENT STYLES\n   ========================================= */\n.profile-page-wrapper.skeleton-mode {\n  pointer-events: none;\n  min-height: 100vh;\n  background: var(--profile-bg);\n  padding: 1.5rem 1rem;\n}\n\n.skeleton-pulse {\n  background: linear-gradient(90deg,\n      var(--muted) 25%,\n      var(--border) 50%,\n      var(--muted) 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite linear;\n  border-radius: var(--radius);\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-title {\n  height: 2.5rem;\n  width: 15rem;\n  margin: 0 auto 2rem;\n  border-radius: 999px;\n  opacity: 0.5;\n}\n\n.skeleton-header-card {\n  height: 10rem;\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto 1.5rem;\n}\n\n.skeleton-tabs {\n  height: 4rem;\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto 1.5rem;\n  border-radius: 1rem;\n}\n\n.skeleton-avatar-card {\n  height: 20rem;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.skeleton-info-card {\n  height: 30rem;\n  width: 100%;\n}\n\n.personal-container {\n  display: grid;\n  gap: 1.5rem;\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n  .personal-container {\n    grid-template-columns: 280px 1fr;\n  }\n}\n\n/* Image Modal */\n.cursor-zoom-in {\n  cursor: zoom-in;\n}\n\n.profile-image-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.profile-image-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  border-radius: 1rem;\n  overflow: hidden;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  background: transparent;\n}\n\n.profile-full-image {\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 90vh;\n  object-fit: contain;\n  border-radius: 0.5rem;\n  display: block;\n}\n\n.profile-modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.profile-modal-close:hover {\n  background: white;\n  color: black;\n  transform: rotate(90deg);\n}\n\n/* Problem Statement Items */\n.problem-statement-item {\n  padding: 1rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  /* Default transparent border */\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.03);\n  /* Default dark mode bg */\n  position: relative;\n  margin-bottom: 0.5rem;\n}\n\n[data-theme='light'] .problem-statement-item {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  /* Visible border in light mode */\n  color: #212529;\n}\n\n.problem-statement-item:hover {\n  border-color: #22c55e;\n  /* Green border on hover */\n  background: rgba(34, 197, 94, 0.05);\n  /* Slight green tint */\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.1);\n}\n\n[data-theme='light'] .problem-statement-item:hover {\n  background: #f0fff4;\n  /* Light green in light mode */\n  border-color: #22c55e;\n}\n\n.problem-statement-item.selected {\n  background: rgba(34, 197, 94, 0.15);\n  border-color: #22c55e;\n  box-shadow: 0 0 0 1px #22c55e;\n  /* Highlight selected */\n}\n\n[data-theme='light'] .problem-statement-item.selected {\n  background: #dcffe4;\n  border-color: #16a34a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
